module.exports = __webpack_public_path__ + "static/Viewpointsystem_logo1-814906277e5d2086bacd5013a1267dde.png";